import { generatePercentColor } from "../../../utils";
import { ProgressBarPropsPeople } from "../../../constants/statistics";
import React from "react";

const ProgressBarPeople: React.FC<ProgressBarPropsPeople> = ({
  fact,
  employ,
  unemploy,
  updated
}) => {
  // Цвета для полос прогресса
  const employColor = "rgba(220, 247, 255, 1)"; 
  const unemployColor = "rgba(255, 227, 227, 1)";
  const updatedColor = "rgba(240, 247, 215, 1)"; 

  // Цвета для фона легенды
  const employBackground = "rgba(62, 144, 240, 1)"; // Светло-синий
  const unemployBackground = "rgba(255, 124, 124, 1)"; // Светло-серый
  const updatedBackground = "rgba(85, 185, 56, 1)"; // Светло-серый

  // Сумма всех значений
  const total = employ + unemploy + updated;

  // Процентные доли каждого значения
  const employWidth = (employ / total) * 100;
  const unemployWidth = (unemploy / total) * 100;
  const updatedWidth = (updated / total) * 100;

  return (
    <div
      style={{
        marginTop: 24,
        fontFamily: "SF Pro Display",
        fontSize: "12px",
        color: "#ABABAB",
      }}
    >
      {/* Полоса прогресса */}
      <div style={{ position: "relative", width: "100%", height: "30px" }}>
        {/* Фон полосы */}
        <div
          style={{
            width: "100%",
            height: "100%",
            borderRadius: "2px",
            backgroundColor: "#F5F5F5",
            position: "absolute",
            top: 0,
            left: 0,
          }}
        />
        {/* Заполненная часть для employ */}
        <div
          style={{
            width: `${employWidth}%`,
            height: "100%",
            borderRadius: "2px",
            background: employColor,
            position: "absolute",
            top: 0,
            left: 0,
          }}
        />
        {/* Заполненная часть для unemploy */}
        <div
          style={{
            width: `${unemployWidth}%`,
            height: "100%",
            borderRadius: "2px",
            background: unemployColor,
            position: "absolute",
            top: 0,
            left: `${employWidth}%`,
          }}
        />
        {/* Заполненная часть для updated */}
        <div
          style={{
            width: `${updatedWidth}%`,
            height: "100%",
            borderRadius: "2px",
            background: updatedColor,
            position: "absolute",
            top: 0,
            left: `${employWidth + unemployWidth}%`,
          }}
        />
      </div>

      {/* Линии разделения */}
      <div style={{ position: "relative", height: "19px", marginTop: "8px" }}>
        {[...Array(10)].map((_, index) => (
          <div
            key={index}
            style={{
              position: "absolute",
              left: `${(index * 82.7778).toFixed(2)}px`,
              width: "1px",
              height: "100%",
              backgroundColor: "#E0E0E0",
            }}
          />
        ))}
      </div>

      {/* Текстовые метки */}
      <div className="flex between" style={{ marginTop: "8px" }}>
        <span className="eventDateInfo">0%</span>
        <span className="eventDateInfo">100%</span>
      </div>
      <div className="flex between diageamLegend gap10" style={{ marginTop: 24 }}>
        <div
          className="legendItem"
          style={{
            background: employColor,
            borderLeft: `4px solid ${employBackground}`,
            padding: "12px 24px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 10,
            width: 'calc(32% - 5px)',
            color: '#161032'
          }}
        >
          <div className="text">Нанято</div>
          <div className="text" style={{
            fontSize: 28,
            fontWeight: 300
          }}>
            {`${employ.toLocaleString('ru-RU')}`} <span style={{ color: "#ABABAB" }}>сотрудников</span>
          </div>
        </div>
        <div
          className="legendItem"
          style={{
            background: unemployColor,
            borderLeft: `4px solid ${unemployBackground}`,
            padding: "12px 24px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 10,
            width: 'calc(32% - 5px)',
            color: '#161032'
          }}
        >
          <div className="text">Уволено</div>
          <div className="text" style={{
            fontSize: 28,
            fontWeight: 300
          }}>
            {`${unemploy.toLocaleString('ru-RU')}`} <span style={{ color: "#ABABAB" }}>сотрудников</span>
          </div>
        </div>
        <div
          className="legendItem"
          style={{
            background: updatedColor,
            borderLeft: `4px solid ${updatedBackground}`,
            padding: "12px 24px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 10,
            width: 'calc(32% - 5px)',
            color: '#161032'
          }}
        >
          <div className="text">Переведено на новую должность</div>
          <div className="text" style={{
            fontSize: 28,
            fontWeight: 300
          }}>
            {`${updated.toLocaleString('ru-RU')}`} <span style={{ color: "#ABABAB" }}>сотрудников</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressBarPeople;